import { API_URL } from './utils/constants';

export function fetchVideos(productId: string): Promise<Record<string, any>[]> {
  return fetch(`${API_URL}/v1/product?pdid=${productId}`)
    .then((res) => res.json())
    .then((res) => {
      const {
        ai_meta,
        category1,
        category2,
        category3,
        name: title,
        pid,
        pdid,
      } = res;
      const { faq_list: list = [], short_video_url: video } = ai_meta ?? {};
      return list.map((data: Record<string, any>) => ({
        ...data,
        video,
        product: {
          categories: [category1, category2, category3],
          title,
          pid,
          pdid,
        },
      }));
    });
}
